import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { convertArrayToObject } from "../../helpers/catalog-helper";
import { userNormalLogout, supportLogout } from "../actions";

export interface TaxesState {
  taxTypeDataMap: {};
  taxAreaDataMap: {};
}

const initialState: TaxesState = {
  taxTypeDataMap: {},
  taxAreaDataMap: {}
}

export const taxesSlice = createSlice({
  name: 'taxes',
  initialState,
  reducers: {
    getAllTaxAreasData: (state) => { },
    saveAllTaxAreasData: (state, actions) => {
      state.taxAreaDataMap = actions.payload.response?convertArrayToObject(actions.payload.response, 'mid'):{};
    },
    deleteTaxAreaData: (state, actions) => { },
    saveTaxAreaData: (state, actions) => {},
    updateTaxAreasMap:  (state, actions) => {
      let dataToUpdate:any = cloneDeep(state.taxAreaDataMap);
      dataToUpdate[actions.payload.key] = actions.payload.data;
      state.taxAreaDataMap = dataToUpdate;
    },

    getAllTaxTypesData: (state) => { },
    saveAllTaxTypesData: (state, actions) => {
      state.taxTypeDataMap = actions.payload.response?convertArrayToObject(actions.payload.response, 'mid'):{};
    },
    deleteTaxTypeData: (state, actions) => { },
    saveTaxTypeData: (state, actions) => {},
    updateTaxTypesMap:  (state, actions) => {
      let dataToUpdate:any = cloneDeep(state.taxTypeDataMap);
      dataToUpdate[actions.payload.key] = actions.payload.data;
      state.taxTypeDataMap = dataToUpdate;
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getAllTaxAreasData,
  saveAllTaxAreasData,
  deleteTaxAreaData,
  saveTaxAreaData,
  updateTaxAreasMap,

  getAllTaxTypesData,
  saveAllTaxTypesData,
  deleteTaxTypeData,
  saveTaxTypeData,
  updateTaxTypesMap,
} = taxesSlice.actions;
export default taxesSlice.reducer;